namespace RioERP.Masters {
    export namespace DelhiveryApiDetailsService {
        export const baseUrl = 'Masters/DelhiveryApiDetails';

        export declare function Create(request: Serenity.SaveRequest<DelhiveryApiDetailsRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<DelhiveryApiDetailsRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<DelhiveryApiDetailsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<DelhiveryApiDetailsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "Masters/DelhiveryApiDetails/Create",
            Update = "Masters/DelhiveryApiDetails/Update",
            Delete = "Masters/DelhiveryApiDetails/Delete",
            Retrieve = "Masters/DelhiveryApiDetails/Retrieve",
            List = "Masters/DelhiveryApiDetails/List"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>DelhiveryApiDetailsService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
